<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="出售中" name="sell">
          <span slot="label">出售中 <el-tag size="mini">{{ productCount.sell }}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="仓库中" name="lower">
          <span slot="label">仓库中 <el-tag size="mini">{{ productCount.lower }}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="回收站" name="recovery">
          <span slot="label">回收站 <el-tag size="mini">{{ productCount.recovery }}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="待审核" name="audit">
          <span slot="label">待审核 <el-tag size="mini">{{ productCount.audit }}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="未通过" name="noAudit">
          <span slot="label">未通过 <el-tag size="mini">{{ productCount.noAudit }}</el-tag></span>
        </el-tab-pane>
      </el-tabs>
      <el-form size="small" :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-cascader
            v-model="currCategory"
            ref="cascader"
            clearable
            :options="categoryList"
            :props="{ checkStrictly: true, children: 'children', value: 'categoryId', label: 'name' }"
            @change="changeCategory"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="商品品牌">
          <el-input size="small" v-model="searchForm.productBrand" placeholder="请输入商品品牌"></el-input>
        </el-form-item>
        <el-form-item label="作物病害">
          <el-cascader
            v-model="currDisease"
            ref="disease"
            clearable
            :options="diseaseList"
            :props="{ checkStrictly: true, children: 'children', value: 'id', label: 'name' }"
            @change="changeDisease"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="供应商">
          <div class="max-w460" @click="onSupplierChoose">
            <el-input style="width: 240px" readonly v-model="searchForm.supplierName"
                      placeholder="请选择供应商"></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <!--          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>-->
          <!--          <el-button type="button" style="margin-left: 10px;"-->
          <!--                     @click.stop="resetSearch">重置-->
          <!--          </el-button>-->

          <!--          <el-button type="button" style="margin-left: 10px;"-->
          <!--                     @click.stop="resetES">重置ES-->
          <!--          </el-button>-->
          <el-button type="button" style="margin-left: 10px;" v-if="activeName === 'sell'"
                     @click.stop="batchSetCommission">按供货价设置佣金留存
          </el-button>
        </el-form-item>
      </el-form>
      <el-form size="small" :inline="true">
        <el-form-item>
          <span v-if="this.checkboxValue.length" style="margin-right: 10px">已选择<span
            style="color: red">{{ this.checkboxValue.length }}</span>个产品</span>
          <el-dropdown @command="handleCommand">
            <el-button type="primary">
              更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="category">批量添加分类</el-dropdown-item>
              <el-dropdown-item command="group" v-if="activeName === 'sell'">批量添加分组</el-dropdown-item>
              <el-dropdown-item command="audit" v-if="activeName === 'audit'">批量审核商品</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
        <el-form-item>
          <el-button type="button" style="margin-left: 10px;" v-if="activeName === 'sell' ||  activeName === 'audit'"
                     @click.stop="batchSetCommission2">按建议销售价设置佣金留存
          </el-button>
        </el-form-item>
        <el-form-item label="销量排序">
          <el-select v-model="searchForm.salesActualSort">
            <el-option :value="0" label="无"></el-option>
            <el-option :value="1" label="从大到小"></el-option>
            <el-option :value="2" label="从小到大"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="点击量排序">
          <el-select v-model="searchForm.viewTimesSort">
            <el-option :value="0" label="无"></el-option>
            <el-option :value="1" label="从大到小"></el-option>
            <el-option :value="2" label="从小到大"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="佣金排序">
          <el-select v-model="searchForm.commissionPriceSort">
            <el-option :value="0" label="无"></el-option>
            <el-option :value="1" label="从大到小"></el-option>
            <el-option :value="2" label="从小到大"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button type="button" style="margin-left: 10px;"
                     @click.stop="resetSearch">重置
          </el-button>
        </el-form-item>
        <el-form-item class="fr clearfix">
          <i class="el-icon-s-fold fs-24" v-if="getShowTable===0" @click="setTableShowStatus(1)"></i>
          <i class="el-icon-menu fs-24" v-if="getShowTable===1" @click="setTableShowStatus(0)"></i>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div v-if="getShowTable === 0" class="table-wrap" style="padding: 0px">
        <el-table size="small" ref="p_table"
                  highlight-current-row
                  :row-key="getRowKeys"
                  @selection-change="tableCurrentChange"
                  :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column type="selection" width="44"
                           :reserve-selection="true"></el-table-column>
          <el-table-column prop="productName" label="产品">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                <div class="info">
                  <div class="name">{{ scope.row.productName }}</div>
                  <!--                    <div class="price">￥{{ scope.row.supplierPrice }}</div>-->
                </div>
              </div>
            </template>
          </el-table-column>
          <!--            <el-table-column prop="manufacturer" label="生产企业" width="240px"></el-table-column>-->
          <el-table-column prop="productBrand" label="品牌" width="120px"></el-table-column>
          <!--          <el-table-column prop="categoryName" label="分类" width="220px">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span>-->
          <!--                {{ getShowCategoryName(scope.row.productCategoryReList) }}-->
          <!--              </span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="productPrice" align="center" label="销售价格" width="90px">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.productPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="minCommission" align="center" label="佣金价格" width="120px">
            <template slot-scope="scope">
              {{ scope.row.minCommission }} <span
              v-if=" scope.row.highCommission &&  (scope.row.highCommission !== scope.row.minCommission)">- {{
                scope.row.highCommission
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="salesInitial" label="综合销量" align="center" width="90px">
            <template slot-scope="scope">
              <span>{{ scope.row.salesInitial + scope.row.salesActual }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="salesActual" label="实际销量" align="center" width="90px"></el-table-column>
          <el-table-column prop="viewTimes" label="点击数" align="center" width="90px"></el-table-column>
          <el-table-column prop="createTime" label="发布时间" header-align="center" width="160px"></el-table-column>
          <el-table-column prop="auditRemark" label="拒绝原因" v-if="activeName === 'noAudit'"
                           width="160px"></el-table-column>
          <el-table-column label="操作" width="140px">
            <template slot-scope="scope">
              <el-button v-if="scope.row.auditStatus===10 " @click="editClick(scope.row)"
                         type="text" size="small"
                         v-auth="'/product/product/edit'">编辑
              </el-button>
              <el-button v-if="activeName === 'sell'" @click="changeStatus(scope.row, 20)" type="text" size="small"
                         v-auth="'/product/product/state'">下架
              </el-button>
              <el-button v-if="activeName === 'lower'" @click="changeStatus(scope.row, 10)" type="text" size="small"
                         v-auth="'/product/product/state'">上架
              </el-button>
              <el-button v-if="scope.row.auditStatus===0" @click="editClick(scope.row)" type="text" size="small"
                         v-auth="'/product/product/edit'">审核
              </el-button>
              <el-button @click="commentClick(scope.row)" type="text" size="small"
                         v-auth="'/product/product/comment'">评价
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="getShowTable === 1" v-loading="loading">
        <ul class="flex f-w ">
          <li v-for="(item,index) in tableData" :key="index" style="width: 12.5%" class="p-5 file"
              @click="selectFileFunc(item,index)">
            <ratio-div :radio-value="6800/49">
              <div class="w-full h-full border absolute top-0 left-0">
                <ratio-div :radio-value="100">
                  <div class="w-full h-full absolute top-0 left-0 p-10">
                    <div class="selectedIcon" v-if="hasCheck(item.productId)">
                      <i class="el-icon-check m-l-4"></i>
                    </div>
                    <img v-img-url="item.imagePath" alt="" class="w-full h-full"/>
                    <div class="bottom-shade" @click.stop>
                      <el-button-group class="flex">
                        <el-button class="flex-1" type="primary" v-if="item.auditStatus===10 " @click="editClick(item)"
                                   size="small"
                                   v-auth="'/product/product/edit'">编辑
                        </el-button>
                        <el-button class="flex-1" v-if="activeName === 'sell'" @click="changeStatus(item, 20)"
                                   type="primary"
                                   size="small"
                                   v-auth="'/product/product/state'">下架
                        </el-button>
                        <el-button class="flex-1" v-if="activeName === 'lower'" @click="changeStatus(item, 10)"
                                   type="primary"
                                   size="small"
                                   v-auth="'/product/product/state'">上架
                        </el-button>
                        <el-button class="flex-1" v-if="item.auditStatus===0" @click="editClick(item)" type="primary"
                                   size="small"
                                   v-auth="'/product/product/edit'">审核
                        </el-button>
                        <el-button class="flex-1" @click="commentClick(item)" type="primary" size="small"
                                   v-auth="'/product/product/comment'">评价
                        </el-button>
                      </el-button-group>
                    </div>
                  </div>
                </ratio-div>
                <div class="line-clamp2 p-h-10">
                  {{ item.productName }}
                </div>
                <div class="p-h-10 flex a-center p-t-5">
                  <span class="fs-16 color-red">￥{{ item.productPrice }}</span>
                </div>
              </div>
            </ratio-div>
          </li>
        </ul>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

    <el-dialog title="添加评论" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-press-escape="false"
               top="5vh">
      <el-form size="mini" :model="form" label-width="100px">
        <el-form-item label="商品名称:">
          <p>{{ form.productName }}</p>
        </el-form-item>
        <el-form-item label="商品图片:"><img :src="form.path" width="120px;" v-if="form.path" :isImg="form.path"/>
        </el-form-item>
        <el-form-item label="商品评分:">
          <el-radio-group v-model="form.score">
            <el-radio :label="10">好评</el-radio>
            <el-radio :label="20">中评</el-radio>
            <el-radio :label="30">差评</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="评价内容:">
          <el-input type="textarea" rows="4" resize="false" v-model="form.content"
                    placeholder="请输入评价内容"></el-input>
        </el-form-item>
        <el-form-item label="评价配图：">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.imageList">
              <transition-group>
                <div class="item" v-for="(item, index) in form.imageList" :key="item">
                  <img v-img-url="item.filePath"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                    class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('image', 'imageList')"><i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="发布人头像：">
          <div style="width: 80px;height: 80px;  overflow: hidden;border: 1px dashed #dddddd;border-radius: 50%;">
            <div class="item img-select"
                 style="width: 80px;height: 80px;display: flex;justify-content: center;align-items: center;"
                 @click="openProductUpload('image', 'header')">
              <i class="el-icon-plus" v-if="!form.headerPath"></i>
              <img
                style="max-height: 100%; max-width: 100%;"
                v-img-url="form.headerPath" v-if="form.headerPath"/>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="发布人名称：">
          <el-input style="width: 220px" v-model="form.publishName" placeholder="请输入发布人名称"></el-input>
        </el-form-item>
        <el-form-item label="发布人性别：">
          <el-radio-group style="width: 220px" v-model="form.gender">
            <el-radio :label="0">女</el-radio>
            <el-radio :label="1">男</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发布时间：">
          <el-date-picker
            v-model="form.createTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="发布时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addComment">确 定</el-button>
      </div>
    </el-dialog>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
      上传图片
    </Upload>

    <supplier-choose ref="supplierChoose" :storeType="20" @closeDialog="supplierChooseOk"/>

    <el-dialog title="批量设置佣金" :visible.sync="commissionSetVisible" @close="commissionSetdialogFormVisible"
               :close-on-press-escape="false"
               top="5vh">
      <el-form size="mini" :model="commissionForm" label-width="120px" ref="commissionForm">
        <el-form-item label="供应商：" prop="shopSupplierId" :rules="[{ required: true, message: '请选择供应商' }]">
          <div style="width: 220px" @click="onDialogSupplierChoose">
            <el-input style="width: 220px" readonly v-model="commissionForm.supplierName"
                      placeholder="请选择供应商"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="留存比例：">
          <el-input v-money style="width: 220px" v-model="commissionForm.retentionRatioValue"
                    placeholder="请输入留存比例"></el-input>
          <span>%</span>
        </el-form-item>
        <el-form-item label="销售佣金比例：">
          <el-input v-money style="width: 220px" v-model="commissionForm.saleCommissionRatioValue"
                    placeholder="请输入销售佣金比例"></el-input>
          <span>%</span>
        </el-form-item>
        <el-form-item label="技术补贴比例：">
          <el-input v-money style="width: 220px" v-model="commissionForm.technologyCommissionRatioValue"
                    placeholder="请输入技术补贴比例"></el-input>
          <span>%</span>
        </el-form-item>
        <el-form-item label="平台补贴比例：">
          <el-input v-money style="width: 220px" v-model="commissionForm.platformCommissionRatioValue"
                    placeholder="请输入平台补贴比例"></el-input>
          <span>%</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="commissionSetVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addcommissionSet">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量设置佣金" :visible.sync="commissionSetVisible2" @close="commissionSetdialogFormVisible"
               :close-on-press-escape="false"
               top="5vh">
      <el-form size="mini" :model="commissionForm" label-width="120px" ref="commissionForm2">
        <el-form-item label="供应商：" prop="shopSupplierId" :rules="[{ required: true, message: '请选择供应商' }]">
          <div style="width: 220px" @click="onDialogSupplierChoose">
            <el-input style="width: 220px" readonly v-model="commissionForm.supplierName"
                      placeholder="请选择供应商"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="留存比值：">
          <el-input-number :min="0" :precision="0" style="width: 220px" v-model="commissionForm.retentionRatioValue"
                           placeholder="请输入留存比值"></el-input-number>
        </el-form-item>
        <el-form-item label="销售佣金比值：">
          <el-input-number :min="0" :precision="0" style="width: 220px"
                           v-model="commissionForm.saleCommissionRatioValue"
                           placeholder="请输入销售佣金比值"></el-input-number>
        </el-form-item>
        <el-form-item label="技术补贴比值：">
          <el-input-number :min="0" :precision="0" style="width: 220px"
                           v-model="commissionForm.technologyCommissionRatioValue"
                           placeholder="请输入技术补贴比值"></el-input-number>
        </el-form-item>
        <el-form-item label="平台补贴比值：">
          <el-input-number :min="0" :precision="0" style="width: 220px"
                           v-model="commissionForm.platformCommissionRatioValue"
                           placeholder="请输入平台补贴比值"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="commissionSetVisible2=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addcommissionSet2">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择分类" :visible.sync="categoryVisible" @close="categoryFormClose"
               :close-on-press-escape="false"
               top="5vh">
      <el-form size="mini" :model="categoryForm" label-width="100px" ref="categoryForm">
        <el-form-item label=" ">
          <div>
            已选择 <span style="color: red">{{ this.checkboxValue.length }}</span>个产品
          </div>
        </el-form-item>
        <el-form-item label="选择分类：">
          <el-cascader style="width: 400px"
                       v-model="categoryForm.categoryIds"
                       ref="selectcascader"
                       clearable
                       :options="categoryList"
                       :props="{ children: 'children', value: 'categoryId', label: 'name' }"
                       @change="selectChangeCategory"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="categoryVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="AddCategory">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量审核" :visible.sync="auditVisible" @close="auditFormClose"
               :close-on-press-escape="false"
               top="5vh">
      <el-form size="small" label-position="left" :model="auditForm" label-width="100px">
        <Audit></Audit>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="auditVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="AddAudit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择分组" :visible.sync="groupVisible" @close="categoryFormClose"
               :close-on-press-escape="false"
               top="5vh">
      <el-form size="mini" :model="groupForm" label-width="100px" ref="categoryForm">
        <el-form-item label=" ">
          <div>
            已选择 <span style="color: red">{{ this.checkboxValue.length }}</span>个产品
          </div>
        </el-form-item>
        <el-form-item label="选择分组：">
          <el-cascader style="width: 400px"
                       v-model="groupForm.groupIds"
                       ref="groupcascader"
                       clearable
                       :options="groupList"
                       :props="{ children: 'children', value: 'id', label: 'name' }"
                       @change="selectChangeGroup"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="groupVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="AddGroup">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js'
import draggable from 'vuedraggable'
import Upload from '@/components/file/Upload'
import SupplierChoose from '../../supplier/supplier/dialog/SupplierChoose'
import Audit from './part/Audit.vue'
import RatioDiv from '../../../components/common/RatioDiv'
import {mapActions, mapGetters} from 'vuex'

export default {
  components: {
    RatioDiv,
    SupplierChoose,
    draggable,
    Upload,
    Audit
  },
  data () {
    return {
      /*切换菜单*/
      activeName: 'sell',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 16,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        productName: '',
        categoryId: '',
        shopSupplierId: '',
        supplierName: '',
        diseaseId: '',
        salesActualSort: 1,
        viewTimesSort: 0,
        commissionPriceSort: 0
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      productCount: {},
      dialogVisible: false,
      form: {
        content: '',
        imageList: [],
        productId: 0,
        productName: '',
        score: 10,
        path: '',
        headerPath: '',
        publishName: '',
        gender: '',
        createTime: ''
      },
      config: {},
      isProductUpload: false,
      file_name: 'image',
      commissionForm: {
        type: '',
        shopSupplierId: '',
        supplierName: '',
        retentionRatioValue: 0,
        saleCommissionRatioValue: 0,
        technologyCommissionRatioValue: 0,
        platformCommissionRatioValue: 0,
      },
      commissionFormRule: {
        shopSupplierId: [{
          required: true, message: '请选择供应商'
        }]
      },
      commissionSetVisible: false,
      commissionSetVisible2: false,
      chooseType: 0,
      /*当前选中的*/
      currCategory: [],
      checkboxValue: [],
      categoryVisible: false,
      categoryForm: {
        categoryId: '',
        categoryIds: []
      },
      auditVisible: false,
      auditForm: {
        model: {
          auditStatus: 10,
          auditRemark: ''
        }
      },
      currDisease: [],
      diseaseList: [],
      groupVisible: false,
      groupForm: {
        groupId: '',
        groupIds: []
      },
      groupList: [],
      multipleSelection: [],
    }
  },
  computed: {
    getShowTable () {
      return this.getTableShow() || 0
    },
    ...mapGetters('common', {
      getTableShow: 'getTableShow'
    })
  },
  provide: function () {
    return {
      form: this.auditForm
    }
  },
  created () {
    /*获取列表*/
    this.getData()
  },
  methods: {
    getRowKeys (row) {
      return row.productId
    },
    /*监听复选按钮选中事件*/
    tableCurrentChange (val) {
      this.multipleSelection = val
      this.checkboxValue = this.multipleSelection.map(res => {
        return res.productId
      })
    },
    changeCategory (e) {
      let item = this.$refs['cascader'].getCheckedNodes()
      if (item && item.length) {
        this.searchForm.categoryId = item[0].data.categoryId
      } else {
        this.searchForm.categoryId = ''
      }
    },
    changeDisease (e) {
      let item = this.$refs['disease'].getCheckedNodes()
      if (item && item.length) {
        this.searchForm.diseaseId = item[0].data.id
      } else {
        this.searchForm.diseaseId = ''
      }
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },

    /*切换菜单*/
    handleClick (tab, event) {
      let self = this
      self.curPage = 1
      self.getData()
      this.checkboxValue = []
      this.multipleSelection = []
      this.$refs.p_table.clearSelection()
    },
    resetSearch () {
      this.searchForm = {
        productName: '',
        categoryId: '',
        shopSupplierId: '',
        supplierName: ''
      }
      this.curPage = 1
      this.currCategory = []
      this.getData()
    },
    resetES () {
      PorductApi.resetES({}).then(data => {
        self.$message({
          message: '操作成功',
          type: 'success'
        })
      })
    },
    batchSetCommission () {
      this.commissionForm = {
        shopSupplierId: '',
        supplierName: '',
        retentionRatioValue: 0,
        saleCommissionRatioValue: 0,
        technologyCommissionRatioValue: 0,
        platformCommissionRatioValue: 0,
      }
      this.commissionSetVisible = true
    },

    batchSetCommission2 () {
      this.commissionForm = {
        type: this.activeName,
        shopSupplierId: '',
        supplierName: '',
        retentionRatioValue: 0,
        saleCommissionRatioValue: 0,
        technologyCommissionRatioValue: 0,
        platformCommissionRatioValue: 0,
      }
      this.commissionSetVisible2 = true
    },

    /*获取列表*/
    getData () {
      let self = this
      let Params = Object.assign({}, self.searchForm)
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.type = self.activeName
      if (!Params.shopSupplierId) {
        delete Params.shopSupplierId
      }
      delete Params.supplierName
      self.loading = true
      PorductApi.productList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.productList.records
          self.categoryList = res.data.categoryList
          self.groupList = res.data.groupList
          self.diseaseList = res.data.diseaseList
          self.totalDataNumber = res.data.productList.total
          self.productCount = res.data.productCount
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },

    /*打开添加*/
    addClick () {
      this.$router.push('/product/product/add')
    },

    /*打开编辑*/
    editClick (row) {
      console.log(row)
      this.$router.push({
        path: '/product/product/edit',
        query: {
          productId: row.productId,
          scene: 'edit'
        }
      })
    },

    linkClick: function (val) {
      let self = this
      let copyText = 'pages/product/detail/detail?productId=' + val
      self.$copyText(copyText).then(function (e) {
        self.$message({
          showClose: true,
          message: '复制成功',
          type: 'success'
        })
      }, function (e) {
        self.$message({
          showClose: true,
          message: '复制失败',
          type: 'error'
        })
      })
    },
    /*打开复制*/
    copyClick (row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          productId: row.productId,
          scene: 'copy'
        }
      })
    },
    /*删除*/
    delClick: function (row) {
      let self = this
      let msg = ''
      if (row.productStatus == 30) {
        msg = '删除后不可恢复，确认删除该记录吗?'
      } else {
        msg = '删除后将移动到回收站，确定删除该记录吗?'
      }
      self
        .$confirm(msg, '提示', {
          type: 'warning'
        })
        .then(() => {
          PorductApi.delProduct({
            productId: row.productId
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            })
            self.getData()
          })
        })
    },
    /*修改状态*/
    changeStatus (item, value) {
      let self = this
      let msg = ''
      if (value == 10) {
        msg = '确认要上架该商品吗?'
      } else {
        msg = '确认要下架该商品吗?'
        if (self.activeName == 'recovery') {
          msg = '确认要移动该商品到仓库吗?'
        }
      }
      self.$confirm(msg, '提示', {
        type: 'warning'
      })
        .then(() => {
          PorductApi.changeStatus({
            productId: item.productId,
            state: value
          }).then(data => {
            self.$message({
              message: '操作成功',
              type: 'success'
            })
            self.getData()
          })
        })
    },
    commentClick (row) {
      this.form = {
        content: '',
        imageList: [],
        productId: row.productId,
        productName: row.productName || '',
        score: 10,
        path: row.imagePath || '',
        headerPath: '',
        publishName: '',
        gender: 0,
        createTime: ''
      }
      this.dialogVisible = true
    },
    addComment () {
      let self = this
      let params = {}
      Object.assign(params, this.form)
      PorductApi.addProductComment(params, true).then(data => {
        self.$message({
          message: '操作成功',
          type: 'success'
        })
        self.dialogVisible = false
      })
    },
    dialogFormVisible (e) {
      this.form = {
        content: '',
        imageList: [],
        productId: 0,
        productName: '',
        score: 10,
        headerPath: '',
        publishName: '',
        gender: 0,
        createTime: ''
      }
    },
    commissionSetdialogFormVisible () {
      this.commissionForm = {
        shopSupplierId: '',
        supplierName: '',
        retentionRatioValue: 0,
        saleCommissionRatioValue: 0,
        technologyCommissionRatioValue: 0,
        platformCommissionRatioValue: 0,
      }
    },
    addcommissionSet () {
      let self = this
      this.$refs.commissionForm.validate(valid => {
        if (valid) {
          self.$confirm('此操作将批量把供应商 <span style="color:red">' + self.commissionForm.supplierName + '</span>的平台留存和商品佣金修改为（按供货价设比）:' +
            ' <br>留存比例 <span style="color:red">' + self.commissionForm.retentionRatioValue + '%</span>' +
            ' <br>销售佣金比例 <span style="color:red">' + self.commissionForm.saleCommissionRatioValue + '%</span>' +
            ' <br>技术补贴比例 <span style="color:red">' + self.commissionForm.technologyCommissionRatioValue + '%</span>' +
            ' <br>平台补贴比例 <span style="color:red">' + self.commissionForm.platformCommissionRatioValue + '%</span>' +
            ',<br><span style="color:red">此修改后不可恢复</span>，是否继续?', '提示', {
            confirmButtonText: '确定修改',
            cancelButtonText: '取消修改',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }).then(() => {
            let params = {}
            Object.assign(params, self.commissionForm)
            PorductApi.setProductCommission(params, true).then(data => {
              self.$message({
                message: '操作成功',
                type: 'success'
              })
              self.commissionSetVisible = false
            })
          }).catch(() => {
            self.commissionSetVisible = false
          })
        }
      })
    },
    addcommissionSet2 () {
      let self = this
      let retentionRatioValue = parseInt(self.commissionForm.retentionRatioValue || 0)
      let saleCommissionRatioValue = parseInt(self.commissionForm.saleCommissionRatioValue || 0)
      let technologyCommissionRatioValue = parseInt(self.commissionForm.technologyCommissionRatioValue || 0)
      let platformCommissionRatioValue = parseInt(self.commissionForm.platformCommissionRatioValue || 0)
      let total = retentionRatioValue + saleCommissionRatioValue + technologyCommissionRatioValue + platformCommissionRatioValue
      if (total <= 0) {
        return this.$message.info('请输入分配比例')
      }
      this.$refs.commissionForm2.validate(valid => {
        if (valid) {
          self.$confirm('此操作将批量把供应商 <span style="color:red">' + self.commissionForm.supplierName + '</span>的平台留存和商品佣金修改为（按建议销售价-供货价差值设比）:' +
            ' <br>留存比值 <span style="color:red">' + self.commissionForm.retentionRatioValue + '/' + total + '</span>' +
            ' <br>销售佣金比值 <span style="color:red">' + self.commissionForm.saleCommissionRatioValue + '/' + total + '</span>' +
            ' <br>技术补贴比值 <span style="color:red">' + self.commissionForm.technologyCommissionRatioValue + '/' + total + '</span>' +
            ' <br>平台补贴比值 <span style="color:red">' + self.commissionForm.platformCommissionRatioValue + '/' + total + '</span>' +
            ',<br><span style="color:red">没有建议销售价的不可处理，此修改后不可恢复</span>，是否继续?', '提示', {
            confirmButtonText: '确定修改',
            cancelButtonText: '取消修改',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }).then(() => {
            let params = {}
            Object.assign(params, self.commissionForm)
            PorductApi.setProductCommission2(params, true).then(data => {
              self.$message({
                message: '操作成功',
                type: 'success'
              })
              self.commissionSetVisible2 = false
            })
          }).catch(() => {
            self.commissionSetVisible2 = false
          })
        }
      })
    },
    returnProductImgsFunc (e) {
      if (e != null) {
        // 兼容后端
        if (e.length > 0) {
          if (this.file_name === 'imageList') {
            this.form.imageList = this.form.imageList.concat(e)
          } else if (this.file_name === 'header') {
            this.form.headerPath = e[0].filePath
          }
        }
      }
      this.isProductUpload = false
    },
    /*删除商品图片*/
    deleteImg (index) {
      this.form.imageList.splice(index, 1)
    },
    /*打开上传图片*/
    openProductUpload: function (file_type, file_name) {
      this.file_name = file_name
      if (this.file_name === 'imageList') {
        this.config = {
          total: 9,
          fileType: file_type
        }
      } else if (this.file_name === 'header') {
        this.config = {
          total: 1,
          fileType: file_type
        }
      }

      this.isProductUpload = true
    },
    getShowCategoryName (list) {
      let text = ''
      if (list && list.length) {
        text = list.map(item => {
          return item.categoryName
        }).join(',')
      }
      return text
    },
    onSupplierChoose () {
      this.chooseType = 1
      this.$refs.supplierChoose.show()
    },
    onDialogSupplierChoose () {
      this.chooseType = 2
      this.$refs.supplierChoose.show()
    },
    supplierChooseOk (e) {
      console.log(e)
      if (e.type === 'success') {
        if (this.chooseType === 1) {
          this.searchForm.shopSupplierId = e.params.shopSupplierId || ''
          this.searchForm.supplierName = e.params.name || ''
        } else if (this.chooseType === 2) {
          this.commissionForm.shopSupplierId = e.params.shopSupplierId || ''
          this.commissionForm.supplierName = e.params.name || ''
        }
      }
    },
    batchAddCategory () {
      if (this.checkboxValue && this.checkboxValue.length) {
        this.categoryVisible = true
      } else {
        this.$message.info('请选择产品')
      }
    },
    batchAddGroup () {
      if (this.checkboxValue && this.checkboxValue.length) {
        this.groupVisible = true
      } else {
        this.$message.info('请选择产品')
      }
    },
    categoryFormClose () {
      this.checkboxValue = []
      this.multipleSelection = []
      this.$refs.p_table.clearSelection()
      this.categoryForm = {
        categoryId: '',
        categoryIds: []
      }
      this.groupForm = {
        groupId: '',
        groupIds: []
      }
    },
    AddCategory () {
      let self = this
      if (this.categoryForm.categoryId) {
        self.loading = true
        let Params = {
          productIds: this.checkboxValue,
          categoryId: this.categoryForm.categoryId
        }
        PorductApi.batchAddCategory(Params, true).then(res => {
          self.$message({
            message: '设置成功',
            type: 'success'
          })
          self.getData()
          self.loading = false
          self.categoryVisible = false
        }).catch(error => {
          self.loading = false
        })
      } else {
        this.$message.info('请选择分类')
      }
    },

    AddGroup () {
      let self = this
      if (this.groupForm.groupId) {
        self.loading = true
        let params = {
          groupId: self.groupForm.groupId,
          productList: this.checkboxValue
        }
        PorductApi.addGroupProduct(params, true).then(res => {
          self.$message({
            message: '添加成功',
            type: 'success'
          })
          self.getData()
          self.loading = false
          self.groupVisible = false
        }).catch(error => {
          self.loading = false
        })
      } else {
        this.$message.info('请选择分组')
      }
    },
    selectChangeCategory (e) {
      let item = this.$refs['selectcascader'].getCheckedNodes()
      if (item && item.length) {
        this.categoryForm.categoryId = item[0].data.categoryId
      } else {
        this.categoryForm.categoryId = ''
      }
    },
    selectChangeGroup (e) {
      let item = this.$refs['groupcascader'].getCheckedNodes()
      if (item && item.length) {
        this.groupForm.groupId = item[0].data.id
      } else {
        this.groupForm.groupId = ''
      }
    },
    handleCommand (command) {
      switch (command) {
        case 'category':
          this.batchAddCategory()
          break
        case 'audit':
          this.batchAudit()
          break
        case 'group':
          this.batchAddGroup()
          break
      }
    },
    batchAudit () {
      if (this.checkboxValue && this.checkboxValue.length) {
        this.auditForm.model = {
          auditStatus: 10,
          auditRemark: ''
        }
        this.auditVisible = true
      } else {
        this.$message.info('请选择产品')
      }
    },
    auditFormClose () {
      this.checkboxValue = []
      this.multipleSelection = []
      this.$refs.p_table.clearSelection()
      this.auditForm.model = {
        auditStatus: 10,
        auditRemark: ''
      }
    },
    AddAudit () {
      let self = this
      if (this.auditForm.model.auditStatus) {
        self.loading = true
        let Params = {
          productIds: this.checkboxValue,
          auditStatus: this.auditForm.model.auditStatus,
          auditRemark: this.auditForm.model.auditRemark
        }
        PorductApi.batchAddAudit(Params, true).then(res => {
          self.$message({
            message: '设置成功',
            type: 'success'
          })
          self.getData()
          self.loading = false
          self.auditVisible = false
        }).catch(error => {
          self.loading = false
        })
      } else {
        this.$message.info('请选择审核状态')
      }
    },
    hasCheck (productId) {
      let result = false
      if (this.checkboxValue.indexOf(productId) !== -1) {
        result = true
      }
      return result
    },

    /*选择图片*/
    selectFileFunc (item, index) {
      let productId = item.productId
      let indexOf = this.checkboxValue.indexOf(productId)
      if (indexOf === -1) {
        this.checkboxValue.push(productId)
        this.multipleSelection.push(item)
      } else {
        this.checkboxValue.splice(indexOf, 1)
        let t_index = this.multipleSelection.findIndex(e => {
          return e.productId === productId
        })
        this.multipleSelection.splice(t_index, 1)
      }
    },
    setTableShowStatus (value) {
      this.setTableShow(value)
      if (value === 0) {
        this.$nextTick(() => {
          this.$refs.p_table.clearSelection()
          this.multipleSelection.forEach(row => {
            this.$refs.p_table.toggleRowSelection(row, true)
          })
        })
      }
    },
    ...mapActions({
        setTableShow: 'common/setTableShow'
      }
    )
  }
}
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.selectedIcon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 10px;
  left: 10px;
  background: #ff9900;
  z-index: 1;
  color: #FFFFFF;
  cursor: pointer;
}

li.file:hover .bottom-shade {
  display: block;
}

li.file .bottom-shade {
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: calc(100% - 20px);
  display: none;
  transform: all 0.2s ease-out 0s;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/index.vue